<template>
    <span class="text-nowrap">
        <LanguageLabel :languages="document.language" hide-name />
        <DataLabel
            :item="item"
            :href="href"
            :none="$t('documents.nil')"
            v-on="$listeners">
            <i
                v-if="document.is_archived"
                v-tooltip
                class="ml-2 text-muted fa fa-fw fa-archive text-muted"
                title="arquivado" />

            <CountBadge :count="document.messages_count" :title="$t('messages.unread')" />

            <ExhibitionTags v-if="withTags" class="ml-2" :related="document" />
        </DataLabel>
    </span>
</template>

<script>
import CountBadge from '@/js/components/common/badges/CountBadge';
import DataLabel from '@/js/components/common/labels/DataLabel';
import LanguageLabel from '@/js/components/common/labels/LanguageLabel';
import ExhibitionTags from '@/js/components/common/badges/ExhibitionTags';

export default {
    name: 'DocumentLabel',

    components: {ExhibitionTags, CountBadge, DataLabel, LanguageLabel},

    props: {
        document: {type: Object, required: true},
        publication: {type: Object, default: null},
        withTags: {type: Boolean},
        withLink: {type: Boolean},
    },

    computed: {
        item() {
            return {
                name: this.document.code,
                deleted_at: this.document.deleted_at,
            };
        },

        href() {
            if (!this.withLink) {
                return null;
            }

            if (!this.publication) {
                return null;
            }

            if (this.$gate.deny('read', 'document', this.document)) {
                return null;
            }

            return this.$toRoute('publications.documents.show', {
                publication: this.publication.id_cpub,
                document: this.document.code,
            }).toString();
        },
    },
};
</script>
